import { getRechargeList, addRecharge, updateRecharge, delRechargeById, updateRechargeStatusById } from '@/api/home/recharge'
import { message } from 'ant-design-vue'
import { useUserStore } from '@/store'

export class rechargeController {
  static async list () {
    const { data } = await getRechargeList(useUserStore().userInfo.agent.category)
    return {
      data: data.records,
      total: data.total
    }
  }

  static async add (data: HOME.RECHARGE) {
    const { code, msg } = await addRecharge({
      ...data,
      category: useUserStore().userInfo.agent.category
    })
    code === 0 ? message.success('新增成功') : message.error(msg)
    return code
  }

  static async update (data: HOME.RECHARGE) {
    const { code, msg } = await updateRecharge(data)
    code === 0 ? message.success('修改成功') : message.error(msg)
    return code
  }

  static async del (id: string) {
    const { code, msg } = await delRechargeById(id)
    code === 0 ? message.success('删除成功') : message.error(msg)
    return code
  }

  static async updateStatus (id: string, isEnabled: boolean) {
    const { code, msg } = await updateRechargeStatusById(id, isEnabled)
    code === 0 ? message.success('修改成功') : message.error(msg)
  }
}
